module.exports = __webpack_public_path__ + "img/back.ea0e14e2.svg";